import React from "react";
import { FaInstagram, FaWhatsapp, FaTiktok } from "react-icons/fa"; // Import social media icons
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer className='bg-dark text-white py-4 mt-3 upper-footer'>
      <div className='container text-center'>
        <div className='mb-3'>
          <Link
            to='https://www.instagram.com'
            target='_blank'
            className='text-white mx-2'
          >
            <FaInstagram size={30} />
          </Link>
          <Link
            to='https://wa.me/your-number'
            target='_blank'
            className='text-white mx-2'
          >
            <FaWhatsapp size={30} />
          </Link>
          <Link
            to='https://www.tiktok.com'
            target='_blank'
            className='text-white mx-2'
          >
            <FaTiktok size={30} />
          </Link>
        </div>
        <div>
          <p>e-commerce king copyright © 2024</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
